import {submit} from './submit'
import downapp from '../../../tools/mgtv/downapp'
import to_casher from '../../../tools/mgtv/casher'
import {openLink} from '../../../tools/mgtv/link'
import {error_event} from '../../../tools/mgtv/analysis'
import {isUndefined,isArray} from '../../../tools/typeof'

function getRecvInfo(award_info) {
  if (!award_info.recv_info) {
    return null
  }
  let info = award_info.recv_info.info;
  if (!info) {
    return null
  }
  const res = {};
  try {
    info = JSON.parse(info)
    if(isArray(info)){
      info.forEach((item) => {
        res[item.label] = item.value;
      });
    }else{
      return null
    }
  } catch (e) {
    return null
  }
  return res;
}

export default function process_award(award_info) {

  console.log('process_award', award_info, award_info.award_type)
  const award_name = award_info.award_name;
  const recv_info = getRecvInfo(award_info);

  let submit_info = {};
  try {
    if (award_info.submit_info) {
      submit_info = JSON.parse(award_info.submit_info);
    }
  } catch (e) {
    error_event(e, "process_award");
  }


  //约定${NAME}为奖品名称
  let title = submit_info.title;
  let tip = submit_info.tip;
  let already_tip = "";
  if (award_info.already_get) {
    already_tip = submit_info.tip;
  }
  ;


  //默认文案
  if (isUndefined(title)) {
    switch (award_info.award_type) {
      case 0:
        title = "${N}";
        break;
      default:
        title = "恭喜您获得了${N}";
        break;
    }
  }
  if (isUndefined(tip)) {
    switch (award_info.award_type) {
      case 1:
      case 2:
        tip = "请仔细填写以下信息，以便小芒果联系你哟";
        break;
      default:
        tip = "";
        break;
    }
  }
  if (isUndefined(already_tip)) {
    switch (award_info.award_type) {
      case 3:
      case 4:
      case 5:
        already_tip = "（您已经领过啦~）";
        break;
      default:
        already_tip = "";

        break;
    }
  }

  title = title.replace(/\${N\}/g, `<span style="color:#f97a2d;font-size:.36rem;">${award_name}</span>`);
  title = `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.1rem">${title}</div>`;

  tip = `<div style="text-align:center;font-size:.3rem;margin-bottom:.1rem">${tip}</div>`
  already_tip = `<div style="text-align:center;font-size:.24rem;margin-bottom:.1rem">${already_tip}</div>`


  switch (award_info.award_type) {
    case 0:
      window.$act_alert_dialog.show({
        title: title,
        button: '确定'
      }).then(res => {

      }).catch(res => {
      })
      break;
    case 1: //地址
      window.$submit_dialog.show({
        submitDialog: {
          title: `${title}${tip}${already_tip}`,
          submit: recv_info?'已提交':'提交',
          fields: [
            {
              label: '姓名',
              type: 'name',
              placeholder: '请输入姓名',
              min: 2,
              max: 10
            },
            {
              label: '手机号码',
              type: 'tel',
              placeholder: '请输入手机号',
            },
            {
              label: '邮寄地址',
              placeholder: '请输入邮寄地址',
              type: 'address',
              min: 10,
              max: 100
            }
          ]
        },
        submitAction: submit.bind(this, award_info),
        recv_info:recv_info
      }).then(res => {

      }).catch(res => {
      })
      break;
    case 2://电话号码
      window.$submit_dialog.show({
        submitDialog: {
          title: `${title}${tip}${already_tip}`,
          submit: recv_info?'已提交':'提交',
          fields: [
            {
              label: '手机号码',
              type: 'tel',
              placeholder: '请输入手机号',
            }
          ]
        },
        submitAction: submit.bind(this, award_info),
        recv_info:recv_info
      }).then(res => {

      }).catch(res => {
      })
      break;
    case 3://VIP
      window.$act_alert_dialog.show({
        title: `${title}${tip}${already_tip}`,
        button: window.gact.is_h5 ? '去使用' : '确认'
      }).then(res => {
        if (window.gact.is_h5) {
          downapp();
        }
      }).then(res => {

      }).catch(res => {
      })
      break;
    case 4: //代金券
      if (window.gact.is_ios_app) {
        const iphone_app_tip =`<div style="text-align:center;font-size:.3rem;margin-bottom:.1rem">请前往“芒果TV会员”微信公众号，点击"VIP服务-开通会员"登录当前账号使用</div>`;
        window.$act_alert_dialog.show({
          title: `${title}${tip}${iphone_app_tip}${already_tip}`,
          button: '确定'
        }).then(res => {
        }).then(res => {

        }).catch(res => {
        })
      } else {
        window.$act_alert_dialog.show({
          title: `${title}${tip}${already_tip}`,
          button: '成为会员'
        }).then(res => {
          to_casher();
        }).then(res => {

        }).catch(res => {
        })
      }
      break;
    case 5:　//观影券
      window.$act_alert_dialog.show({
        title: `${title}${tip}${already_tip}`,
        button: '确定'
      }).then(res => {

      }).catch(res => {
      })
      break;
    case 6: //链接
      window.$act_alert_dialog.show({
        title: `${title}${tip}${already_tip}`,
        button: '去使用'
      }).then(res => {
        openLink(award_info.link);
      }).catch(res => {
      })
      break;
    case 7: //卡密
      const link = award_info.link;
      window.$act_alert_dialog.show({
        title: `${title}${tip}${already_tip}
        <div style="margin:.1rem auto;border-radius: 0.1rem;padding: 0.2rem 0 ; font-size: 0.26rem; color: #717171;background: #e8e8e8;max-width: 5rem;text-align: center;user-select: all !important;-webkit-user-select:all !important;">${award_info.secret_key}</div>`,
        button: link ? '去使用' : '确认'
      }).then(res => {
        link && openLink(link);
      }).catch(res => {
      })
      break;
    case 13://自定义弹窗类型
      window.$submit_dialog.show({
        submitDialog: {
          title: `${title}${tip}${already_tip}`,
          submit: recv_info?'已提交':'提交',
          fields: submit_info.fields
        },
        submitAction: submit.bind(this, award_info),
        recv_info
      }).then(res => {

      }).catch(res => {
      })
      break;
    default:
      break;
  }


}



// WEBPACK FOOTER //
// ./src/components/ConfigUI/Lottery/process_award.js